import useDetectOnboardingRedirect from "@/shared/hooks/useDetectOnboardingRedirect";

const AdminGlobal = () => {
  useDetectOnboardingRedirect();
  return <></>;
};

export default AdminGlobal;
